// test1941
(1941 && 0);
